import client from "./client";
import type { PlatePreset } from "../components/BookCover/BookCover";

export interface Cover {
  id: number;
  userId: number;
  templateId: number;
  authorName: string;
  receiverName: string;
  bookTitle: string;
  coverUrl: string;
  platePreset?: PlatePreset | null;
}

export const coversApi = {
  get: (templateId: number) =>
    client.get<Cover>(`/covers/${templateId}`),

  upsert: (data: {
    templateId: number;
    authorName: string;
    receiverName?: string;
    bookTitle: string;
    coverUrl?: string;
    platePreset?: PlatePreset;
  }) => client.post<Cover>("/covers", data),
};
